import { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ResetFormData, TOption } from '@src/types';
import { Button, Input, MultiSelect } from '@features/ui';

export const ResetForm: FC<
  UseFormReturn<ResetFormData> & { productOptions: TOption[] }
> = ({ productOptions, control, formState: { isSubmitting, errors } }) => {
  return (
    <div>
      <div className={'text-xs lg:w-[80%] w-full'}>
        <p className={'mb-3.5'}>Reset details</p>
        <div className={'flex w-full lg:flex-row flex-col gap-x-13 gap-y-7'}>
          <Controller
            control={control}
            name="title"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-3.5'}>
                <p>Title</p>
                <div className={'flex flex-col gap-1'}>
                  <Input
                    error={!!errors.title?.message}
                    placeholder={'Enter'}
                    textSize={'xs'}
                    variant={'secondary'}
                    {...field}
                  />
                  <p className={'mt-2.5'}>For your reference</p>
                  {errors.title?.message && (
                    <p className={'text-red-500'}>{errors.title?.message}</p>
                  )}
                </div>
              </div>
            )}
          />
          <Controller
            control={control}
            name="price"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-3.5'}>
                <p>Price</p>
                <div className={'flex flex-col gap-1'}>
                  <Input
                    className={'lg:w-[70%] w-full'}
                    error={!!errors.price?.message}
                    placeholder={'$'}
                    textSize={'xs'}
                    type={'number'}
                    variant={'secondary'}
                    {...field}
                  />
                  {errors.title?.message && (
                    <p className={'text-red-500'}>{errors.price?.message}</p>
                  )}
                </div>
              </div>
            )}
          />
        </div>
        <div
          className={'flex w-full lg:flex-row flex-col gap-x-13 gap-y-7 mt-6'}
        >
          <Controller
            control={control}
            name="allow_reset_of_packages"
            render={({ field }) => (
              <div className={'flex flex-col gap-3.5 flex-1'}>
                <p>Allow reset of packages</p>
                <div>
                  <MultiSelect
                    error={!!errors.allow_reset_of_packages?.message}
                    options={productOptions}
                    placeholder={'Select'}
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <p className={'text-red-500'}>
                    {errors.allow_reset_of_packages?.message}
                  </p>
                </div>
              </div>
            )}
          />
          <div className={'flex-1 lg:flex hidden'} />
        </div>
      </div>
      <div className={'flex w-full justify-end mt-15 mb-7.5 pr-15'}>
        <Button
          loading={isSubmitting}
          size={'sm'}
          type={'submit'}
          variant={'lime'}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
